
import data from './data.json'

export const DEFAULT_OPTIONS = data

const BASE_URL = 'https://etiketki.online';
export default BASE_URL;
export const BASE_S2 = 8;

export const ETIKETKI = [
    {
        id: 1,
        name: 'Готовые наклейки для цветов и подарков',
        description: 'Матовая фотобумага, диаметр 45 мм, 6 видов в линейке',
        image: 'https://etiketki.online/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-02-at-14.51.28.jpeg',
        prices: [
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 200,
                price: 490
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 300,
                price: 690
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 500,
                price: 980
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 1000,
                price: 1800
            }
        ]
    },
    {
        id: 2,
        name: 'Готовые новогодние наклейки',
        description: 'Матовая фотобумага, диаметр 45 мм, 6 видов в линейке. Три разновидности дизайна.',
        image: 'https://etiketki.online/wp-content/uploads/2020/12/WhatsApp-Image-2020-12-02-at-14.41.53.png',
        prices: [
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 200,
                price: 490
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 300,
                price: 690
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 500,
                price: 980
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 45,
                width: 45,
                paper: 'matte_paper',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 1000,
                price: 1800
            }
        ]
    },
    {
        id: 3,
        name: 'Готовые новогодние наклейки.',
        description: ' Серебряная плёнка, диаметр 25 мм, 6 видов в линейке. Шесть разновидностей дизайна.',
        image: 'https://etiketki.online/wp-content/uploads/2020/12/3aad1e96-a8fe-433c-a560-226eb5393a63.png',
        prices: [
            {
                type: 'etiketka',
                shape: 'circle',
                height: 25,
                width: 25,
                paper: 'silver_film',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 200,
                price: 290
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 25,
                width: 25,
                paper: 'silver_film',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 300,
                price: 390
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 25,
                width: 25,
                paper: 'silver_film',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 500,
                price: 590
            },
            {
                type: 'etiketka',
                shape: 'circle',
                height: 25,
                width: 25,
                paper: 'silver_film',
                laminate: 'no',
                sleeve: 'Втулка 76 мм',
                direction: 'not-important',
                distance: 5,
                counts: 1000,
                price: 1000
            }
        ]
    }
];
